import { render, staticRenderFns } from "./TransportDocDetail.vue?vue&type=template&id=5c3e09be&"
import script from "./TransportDocDetail.vue?vue&type=script&lang=js&"
export * from "./TransportDocDetail.vue?vue&type=script&lang=js&"
import style0 from "./TransportDocDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports